import type { ElementType, ReactNode, CSSProperties } from "react";
import { cn } from "@/utils/helpers/classnames";

type TextVariant =
  | "body-lg"
  | "body"
  | "body-sm"
  | "caption"
  | "label";

interface TextProps extends React.HTMLAttributes<HTMLElement> {
  as?: ElementType;
  variant?: TextVariant;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const textVariants: Record<TextVariant, string> = {
  // Large body text (rare, used for intros / hero paragraphs)
  "body-lg": "text-lg leading-7",

  // Default body text (standard reading size)
  body: "text-base leading-6",

  // Small body / secondary text
  "body-sm": "text-sm leading-5",

  // Captions / metadata
  caption: "text-xs leading-4",

  // Labels (form inputs, UI tags)
  label: "text-sm font-medium leading-5",
};

const Text = ({
  as: Component = "p",
  variant = "body",
  children,
  className,
  style,
}: TextProps) => {
  return (
    <Component
      className={cn("font-satoshi text-[#181717]", textVariants[variant], className)}
      style={style}
    >
      {children}
    </Component>
  );
}

export default Text;